const ricercaAssistenteReducer = (state={}, action) => {
    switch (action.type){
        case 'SET_PARAMS_RICERCA':{
            let newState = {...state}
            newState.params = action.params
            return state = newState;
        }
        case 'SET_STATE_RICERCA':{
            let newState = {...state}
            newState.state = action.state
            return state = newState;
        }
        case 'DELETE_PARAMS_RICERCA':{
            return state = {};
        }
        case 'DELETE_STATE_RICERCA':{
            return state = {};
        }
        default : return state
    }
}

export default ricercaAssistenteReducer